var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-5",attrs:{"fluid":"","fill-height":""}},[_vm._v(" 存在しないルーム、もしくは時間が終了したルームです。"),_c('br'),_vm._v(" １０秒後にトップページに戻ります。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }